import ListingUsed from 'inventory-listing/components/ListingUsed/ListingUsed.jsx';
import ListingUsedProvider from 'inventory-listing/ListingUsedProvider.jsx';

const root = ListingUsed;
const provider = ListingUsedProvider;
const main = provider;

export const widgets = {
    ListingUsed: {
        components: {
            root,
            provider,
            main,
        },
    },
};

export default {
    root,
    provider,
    InventoryListing: main,
};



// WEBPACK FOOTER //
// ./client/src/index.js